export default ["lettering", "pangrams", "sentences", "gotchas", "ABCs", "glyphs", "kerning", "languages"];
